import React from 'react'
import { Dialog } from 'primereact/dialog';

const ModalNetwork = ({
    open = false,
    onClose = () => console.log('onClose'),

}) => {
    return (
        <Dialog visible={open} style={{ width: '500px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
            <div className="bModal bCard" id="failModal" style={{ display: 'block' }}>
                <div className="bInner">
                    <div className="bTitle">
                        <span>ไม่สามารถทำการนัดหมายได้</span>
                        <p>
                            ขออภัย เกิดข้อผิดพลาด<br />โปรดทำการนัดหมายใหม่ในภายหลัง<br />(40402)
                        </p>
                    </div>
                    <div className="bBtn">
                        <button className="btn btnCloseModal" onClick={onClose}>กลับสู่หน้าแรก</button>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalNetwork